const createQuery = () => `
  ... on CompanyPartnershipsListWidget {
    partnerships {
      _id
      name
      slug
      images {
        thumbnail_640 {
          url
        }
      }
    }
  }
`

export default createQuery
